import styled from "styled-components";

export const Container = styled.div``;

export const Table = styled.div`
  > div:nth-child(odd) {
    background-color: #e8e8e8;
  }

  > div:nth-child(even) {
    background-color: #f7f7f7ee;
  }

  > div + div {
    margin-top: 24px;
  }
`;
export const ItemTable = styled.div`
  border-radius: 10px;
  padding: 16px;
  display: grid;
  border-radius: 10px;
  grid-template-columns: 1fr 1fr;
  grid-template-areas: "item1 item1" "item2 item2" "item3 item3" "item4 item5";
  align-items: center;

  > :nth-child(1) {
    grid-area: item1;
  }

  > :nth-child(2) {
    grid-area: item2;
  }

  > :nth-child(3) {
    grid-area: item3;
  }

  > :nth-child(4) {
    grid-area: item4;
  }

  > :nth-child(5) {
    grid-area: item5;
    margin-left: auto;
  }

  > p {
    color: #2d2d2d;
    font-family: Mulish;
    font-size: 12px;
    font-style: normal;
    font-weight: 800;
    line-height: 24px;
    letter-spacing: 0.36px;
    text-transform: uppercase;

    > span {
      color: #595959;
      font-family: Mulish;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 24px;
      letter-spacing: 0.36px;
      display: inline;
    }
  }

  button {
    border-radius: 10px;
    background: #20332f;
    padding: 6px 12px;
    color: #fff;
    text-align: center;
    font-family: Mulish;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
  }

  @media (min-width: 640px) {
    grid-template-columns: 1fr 1fr 0.8fr 1fr 0.4fr;
    grid-template-areas: "item1 item2 item3 item4 item5";
  }
`;

export const WrapperPagination = styled.div`
  margin-top: 64px;
`;
